/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import AuthLayout from '../components/common/AuthLayout';
import LoginForm from '../components/common/LoginForm';
import ScrollingColumn from '../components/common/ScrollingColumn';

const LoginPage = () => {
	return (
		<AuthLayout
			left={<LoginForm />}
			right={
				<>
					<ScrollingColumn direction="up" />
					<ScrollingColumn direction="down" />
					<ScrollingColumn direction="up" />
				</>
			}
		/>
	);
};

export default LoginPage;
